export const rosterRestrictions = [
  {
    id: 'permanent',
    label: 'Permanent',
  },
  {
    id: 'temporary',
    label: 'Temporary',
  },
  {
    id: 'non-roster',
    label: 'Non-Roster',
  },
] as const

export type RosterType = (typeof rosterRestrictions)[number]['id']
